var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('div',{staticClass:"certificates-container"},_vm._l((_vm.certificates),function(certificate,i){return _c('div',{key:i},[(certificate.getLogo())?_c('img',{staticClass:"certificate-logo",attrs:{"alt":"Green Energy Certificate","src":certificate.getLogo()}}):_c('div',[_vm._v(_vm._s(certificate.getName()))])])}),0)
}
var staticRenderFns = []

export { render, staticRenderFns }